import React from "react";
import CircleRightTop from "../images/EllipseLeftTop.png";
import CircleLeftBottom from "../images/roundedCommunity2.svg";
import { useTranslation } from "react-i18next";

const PrivacyPolicyMain = () => {
  const { t } = useTranslation();
  return (
    <div className="blogPart_main">
      <img draggable="false"
        src={CircleRightTop}
        className="back_circle1Blogs"
        alt="web3 security"
      />
      <img draggable="false"
        src={CircleLeftBottom}
        className="back_circle2Blogs"
        alt="web3 security"
      />
      <div className="container mx-auto px-2 pb-5 md:pb-0 xl:max-w-[1000px] 3xl:max-w-[1400px]">
        <div className="pt-[150px] sm:pt-[100px] text-center">
          <button className="sora px-4 py-2 text-[#3359D3] border border-opacity-40 border-[#3359D3] rounded-[38px] font-[600]">
            {t("personal_data_Protection")}
          </button>
          <h1 className="sora text-center text-[#000] text-[22px] sm:text-[30px] lg:text-[40px] 3xl:text-[70px] font-[700] leading-[80px]">
            {t("privacy_policy")}
          </h1>
        </div>
        <div className="pt-[50px] lg:pt-[100px]">
          <div>
            <h1 className="sora sm:text-[16px] lg:text-[18px] font-[400] pt-2">
              {t("last_updated")}: 1 May 2024
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px]  md:text-[16px] font-[400] pt-2">
              {t("privacy_policy_para1")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px]  md:text-[16px] font-[400] pt-5">
              {t("privacy_policy_para2")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px]  md:text-[16px] font-[400] pt-5">
              {t("privacy_policy_para3")}
            </h1>
            <h1 className="sora text-[16px]  sm:text-[22px]  lg:text-[34px] font-[600] pt-[30px]">
              {t("info_collect")}
            </h1>
            <hr />
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-2 leading-7">
              {t("privacy_policy_para4")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-5 leading-7">
              {t("privacy_policy_para5")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-5 leading-7">
              {t("privacy_policy_para6")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-5 leading-7">
              {t("privacy_policy_para7")}
            </h1>

            <h1 className="sora text-[16px]  sm:text-[22px]  lg:text-[34px] font-[600] pt-[50px]">
              {t("privacy_policy_para8")}
            </h1>
            <hr />
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-2 leading-7">
              {t("privacy_policy_para9")}
            </h1>

            <h1 className="sora text-[16px]  sm:text-[22px]  lg:text-[34px] font-[600] pt-[50px]">
              {t("privacy_policy_para10")}
            </h1>
            <hr />
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-2 leading-7">
              {t("privacy_policy_para11")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-5 leading-7">
              {t("privacy_policy_para12")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-5 leading-7">
              {t("privacy_policy_para13")}
            </h1>

            <h1 className="sora text-[16px]  sm:text-[22px]  lg:text-[34px] font-[600] pt-[50px]">
              {t("privacy_policy_para14")}
            </h1>
            <hr />
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-2 leading-7">
            {t("privacy_policy_para15")}
            </h1>
            <h1 className="sora text-[#6A6A6A] text-[12px] sm:text-[14px] md:text-[16px] font-[400] pt-2 leading-7">
            {t("privacy_policy_para16")}
            </h1>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyMain;
